import { getRequest, getWithParamsRequest, postRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

// GET
export async function getAlerts(queryParams: QueryParams) {
  return getWithParamsRequest<GetAlertsSuccessResponse>('new/incidents', queryParams);
}

export async function getEmployees(perPage: number) {
  return getWithParamsRequest<GetEmployeesSuccessResponse>('employees', { role: 'live-ops', perPage });
}

export async function getAlertTypes(): Promise<ApiResponse<{ alertTypes: { value: string; label: string }[] }>> {
  return getRequest('new/incidents/types');
}

export async function getAlertClosureReasons(): Promise<
  ApiResponse<{ id: number; key: string; description: string }[]>
> {
  return getRequest('new/incidents/closure_reasons');
}

// POST
export async function assignAlerts(
  alertIds: number[],
  assigneeId: string,
  authenticityToken: string
): Promise<ApiResponse<{ messages: string[] }>> {
  return postRequest('new/incidents/assign', {
    authenticityToken: authenticityToken,
    alertIds: alertIds,
    assigneeId: assigneeId,
  });
}
export async function snoozeAlert(id): Promise<ApiResponse<{ messages: string[] }>> {
  return postRequest(`new/incidents/${id}/snooze`, {});
}

export async function closeAlert(
  id: number,
  reasonKey: string,
  userId: number
): Promise<ApiResponse<{ messages: string[] }>> {
  return postRequest(`new/incidents/${id}/close`, {
    reason_key: reasonKey,
    user_id: userId,
  });
}
